export class DatosFactura {
  emisorRFC: string = '';
  receptorRFC: string = '';
  total: string = '';
  folioFiscal: string = '';

  conceptos: {
    cantidad: string;
    descripcion: string;
    valorUnitario: string;
    importe: string;
  }[] = [];

  impuestosGlobales: {
    traslados: {
      impuesto: string;
      tipoFactor: string;
      tasaOCuota: string;
      importe: string;
      base: string;
    }[];
    retenciones: {
      impuesto: string;
      importe: string;
    }[];
  } = {
    traslados: [],
    retenciones: []
  };

  // Nuevos campos solicitados
  subtotal: string = '0';
  iva: string = '0';
  retencionISR: string = '0';
  retencionIVA: string = '0';
}